var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37216 18.843C7.46378 22.9346 14.0977 22.9346 18.1894 18.843C22.281 14.7513 22.281 8.11741 18.1894 4.02579C14.0977 -0.0658714 7.46382 -0.0658714 3.37216 4.02579C-0.71946 8.11741 -0.719497 14.7513 3.37216 18.843ZM13.559 9.76745C13.8659 9.46058 13.8659 8.96303 13.559 8.65616C13.2521 8.3493 12.7546 8.34929 12.4477 8.65616L10.7808 10.3231L9.11383 8.65616C8.80695 8.34929 8.3094 8.3493 8.00254 8.65616C7.69567 8.96303 7.69567 9.46058 8.00254 9.76745L9.66947 11.4344L8.00254 13.1013C7.69567 13.4082 7.69567 13.9057 8.00254 14.2126C8.3094 14.5195 8.80696 14.5195 9.11383 14.2126L10.7808 12.5457L12.4477 14.2126C12.7546 14.5195 13.2521 14.5195 13.559 14.2126C13.8659 13.9057 13.8659 13.4082 13.559 13.1013L11.8921 11.4344L13.559 9.76745Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCircle);
export default __webpack_public_path__ + "static/media/remove-circle.078d8ab5b30ce001118b5b0fc3079213.svg";
export { ForwardRef as ReactComponent };